import React, {Component} from 'react';
import {observer,inject} from "mobx-react";
import Form from "./Form";

class ReplyForm extends Component {
  render() {
    if(this.props.commentsStore.reply_to._id == this.props.id || (!this.props.commentsStore.reply_to._id && this.props.id===0)) {
      return (
        <div style={{marginLeft:this.props.marginLeft || 0}}>
          <Form onCommentPost={()=>{ if(this.props.onCommentPost) { this.props.onCommentPost(); } }} />
        </div>
      )
    }
    if(this.props.id === 0 || this.props.id === -1) {
      return (
        <div className="pbottom20">
          <span className={`btn4 ${this.props.commentsStore.small_mode?'small':''}`} onClick={()=>{ this.props.commentsStore.replyTo({ _id:this.props.id }); }}><span>Ответить сюда</span></span>
        </div>
      )
    }
    return null;
  }
}

export default inject("commentsStore")(observer(ReplyForm));